import { render, staticRenderFns } from "./MaterialsForDownload.vue?vue&type=template&id=4ec6fefe&scoped=true"
import script from "./MaterialsForDownload.vue?vue&type=script&lang=js"
export * from "./MaterialsForDownload.vue?vue&type=script&lang=js"
import style0 from "./MaterialsForDownload.vue?vue&type=style&index=0&id=4ec6fefe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec6fefe",
  null
  
)

export default component.exports